module.exports = __webpack_public_path__ + "media/images/icons/outlined/sort-ascending-29a0dc9f00a1c210fa75a8407e123a37.svg";